// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"848":"336ec173","936":"1825955b"}[chunkId] + ".chunk.css";
};